import { observer, Observer } from '@poa/state';
import React from 'react';
import AutosizeInput from 'react-input-autosize';
import { ProfileModalHeadSocials } from './profile-modal-head-socials';

export const ProfileModalHead = observer(
  class ProfileModalHead extends React.Component {
    render() {
      const { state, variant, selectedSite } = this.props;
      const isInputsActive = !state.isEditMode;

      if (state.galleryMode === 'photo' || state.galleryMode === 'video') {
        return null;
      }

      switch (variant) {
        case 'staff':
          return (
            <div className="account-head js-subpopup-hide">
              <div className="account-head__top">
                <div className="account-head__col">
                  <div className="account-head__headline">Фамилия</div>
                  <div className="account-head__fullname account-head_devider">
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName="account-head__input"
                          type="text"
                          value={state.model.last_name}
                          onChange={({ target }) => (state.model.last_name = target.value)}
                        />
                      )}
                    </Observer>
                  </div>
                </div>

                <div className="account-head__col">
                  <div className="account-head__headline">Имя</div>
                  <div className="account-head__fullname account-head_devider">
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName="account-head__input"
                          type="text"
                          value={state.model.first_name}
                          onChange={({ target }) => (state.model.first_name = target.value)}
                        />
                      )}
                    </Observer>
                  </div>
                </div>
              </div>
            </div>
          );
        case 'credentials':
          return (
            <div className="account-head js-subpopup-hide">
              <div className="account-head__top">
                <div className="account-head__fullname account-head_devider">
                  <Observer>
                    {() => (
                      <AutosizeInput
                        minWidth={100}
                        disabled={isInputsActive}
                        inputClassName="account-head__input"
                        type="text"
                        value={state.model.title}
                        onChange={({ target }) => (state.model.title = target.value)}
                      />
                    )}
                  </Observer>
                </div>
                <div className="account-head__fullname account-head_devider">
                  <Observer>
                    {() => (
                      <AutosizeInput
                        minWidth={100}
                        disabled={isInputsActive}
                        inputClassName="account-head__input"
                        type="text"
                        value={state.model.login}
                        onChange={({ target }) => (state.model.login = target.value)}
                      />
                    )}
                  </Observer>
                </div>
              </div>
            </div>
          );
        case 'agency':
          return (
            <div className="account-head js-subpopup-hide">
              <div className="account-head__top">
                <div className="account-head__fullname account-head_devider" />
                <div className="account-head__fullname account-head_devider">
                  <Observer>
                    {() => (
                      <AutosizeInput
                        minWidth={100}
                        inputClassName="account-head__input"
                        type="text"
                        disabled={true}
                        value="Агенство"
                      />
                    )}
                  </Observer>
                </div>
              </div>
              {!state.isAdding && (
                <div className="account-head__bot">
                  <div className="account-head__site">
                  </div>
                </div>
              )}
            </div>
          );
        default:
          break;
      }

      return (
        <div className="account-head js-subpopup-hide">
          <div className="account-head__top">
            <div className="account-head__left_column">
            <div className="account-head__col">
              <div className="account-head__headline">Фамилия</div>
              <div className="account-head__fullname account-head_devider">
                <Observer>
                  {() => (
                    <AutosizeInput
                      minWidth={100}
                      disabled={isInputsActive}
                      inputClassName="account-head__input"
                      type="text"
                      value={state.model.lastName}
                      onChange={({ target }) => (state.model.lastName = target.value)}
                    />
                  )}
                </Observer>
              </div>
            </div>
            <div className="account-head__col">
              <div className="account-head__headline">Имя</div>
              <div className="account-head__fullname account-head_devider">
                <Observer>
                  {() => (
                    <AutosizeInput
                      minWidth={100}
                      disabled={isInputsActive}
                      inputClassName="account-head__input"
                      type="text"
                      value={state.model.firstName}
                      onChange={({ target }) => (state.model.firstName = target.value)}
                    />
                  )}
                </Observer>
              </div>
            </div>
            <div className="account-head__col">
              <div className="account-head__headline">Номер аккаунта</div>
              <div className="account-head__number account-head_devider ">
                <Observer>
                  {() => (
                    <AutosizeInput
                      minWidth={100}
                      disabled={isInputsActive}
                      inputClassName="account-head__input"
                      type="text"
                      value={state.model.accountNumber}
                      onChange={({ target }) => (state.model.accountNumber = target.value)}
                    />
                  )}
                </Observer>
              </div>
            </div>

            <Observer>
              {() => <div className="account-head__status active">{state.model.status}</div>}
            </Observer>
            </div>

            <div className="account-head__right_column">
              <div className='account-info__avatar'>
                  <img
                    src={state.model.account[selectedSite.get().value].profilePhoto}
                    alt='kinski' />
            </div>
            </div>
          </div>
          <div className="account-head__center">
            <div className="account-head__col">
              <div className="account-head__headline">реквизиты</div>
              <div className="account-head__cardnumber">
                <Observer>
                  {() => (
                    <AutosizeInput
                      minWidth={100}
                      disabled={isInputsActive}
                      inputClassName="account-head__input"
                      type="text"
                      value={state.model.bankAccountNumber}
                      onChange={({ target }) => (state.model.bankAccountNumber = target.value)}
                    />
                  )}
                </Observer>
              </div>
            </div>

            <div className="account-head__col">
              <ProfileModalHeadSocials state={this.props.state} />
            </div>
          </div>
        </div>
      );
    }
  }
);
